import { flatMap } from "lodash-es";
import splitRangeIntoTwoPartsIfItIsCircular from "./splitRangeIntoTwoPartsIfItIsCircular";
import getOverlapOfNonCircularRanges from "./getOverlapOfNonCircularRanges";
export default function getOverlapsOfPotentiallyCircularRanges(rangeA, rangeB, maxRangeLength, joinIfPossible) {
  const normalizedRangeA = splitRangeIntoTwoPartsIfItIsCircular(
    rangeA,
    maxRangeLength
  );
  const normalizedRangeB = splitRangeIntoTwoPartsIfItIsCircular(
    rangeB,
    maxRangeLength
  );
  let overlaps = [];
  normalizedRangeA.forEach(function(nonCircularRangeA) {
    normalizedRangeB.forEach(function(nonCircularRangeB) {
      const overlap = getOverlapOfNonCircularRanges(
        nonCircularRangeA,
        nonCircularRangeB
      );
      if (overlap) {
        overlaps.push(overlap);
      }
    });
  });
  if (joinIfPossible && normalizedRangeA.length === 2 && normalizedRangeB.length === 2 && maxRangeLength) {
    const joinedOverlap = {};
    overlaps = flatMap(overlaps, (o) => {
      if (o.start === 0) {
        joinedOverlap.end = o.end;
        return [];
      } else if (o.end === maxRangeLength - 1) {
        joinedOverlap.start = o.start;
        return [];
      }
    });
    overlaps.push(joinedOverlap);
  }
  return overlaps;
}
